<template>
    <div>
        <div class="d-flex justify-content-center flex-column align-items-center">
            <div class="search-by-name-filter shadow-sm" v-if="showSearchByNameFilter">
                <Multiselect @filter="filter" />
            </div>
        </div>
        <div class="search-by-name-icon-menu filter shadow-sm" @click="show = !show">
            <i class="fas fa-search"/>
        </div>
    </div>
</template>

<script>
import Multiselect from '../elements/Multiselect'
export default {
    name: 'SearchByNameFilter',
    data() {
        return {
            show: false,
        }
    },
    components: {Multiselect},
    methods: {
        filter(value) {
            this.$emit('filter', value)
        },
    },
    computed: {
        showSearchByNameFilter() {
            return this.show || window.innerWidth > 576
        }
    },
}
</script>

<style scoped lang="scss">
    .search-by-name-filter {
        max-width: 100%;
        border: 1px solid rgba(0, 0, 0, 0.125);
        border-radius: 0.25rem;
        margin-bottom: 1rem;
        min-width: 327px;
        padding: 0 1rem;
        
    }
    @media (min-width: 768px) {

        .search-by-name-filter {
            width: 768px;
        }
    }
    @media (min-width: 576px) {
        .search-by-name-icon-menu{
            display: none;
        }
    }
    @media (max-width: 576px) {
        .search-by-name-icon-menu{
            cursor: pointer;
            position: fixed;
            top: auto;
            bottom: calc(2% + 60px);
            display: block;
            width: 52px;
            z-index: 1;
            left: 2%;
            background-color: #ff9a22;
            height: 56px;
            padding: 0;
            text-align: center;
            border-radius: 5px;
            i{
                color: #fff;
                font-size: 20px;
                line-height: 56px;
            }
        }
    }

</style>